import { useCallback } from 'react';
import MailConnectCard from './MailConnectCard';
import MailDigestCard from './MailDigestCard';
import MailDraftCard from './MailDraftCard';
import MailConfirmCard from './MailConfirmCard';
import MailResultCard from './MailResultCard';
import MailUnsubscribePickerCard from './MailUnsubscribePickerCard';
import MailLinkCard from './MailLinkCard';
import { buildMailFollowUp } from './mailUtils';

export default function MailCard({ card, onA2uiAction, onOpenTarget }) {
  const cardId = card?.cardId || card?.id || null;
  const data = card?.data && typeof card.data === 'object' ? card.data : {};

  const sendFollowUp = useCallback((sourceComponentId, userMessage, context) => {
    onA2uiAction?.(buildMailFollowUp(card, sourceComponentId, userMessage, context));
  }, [card, onA2uiAction]);

  switch (card?.template) {
    case 'mail_connect':
      return <MailConnectCard cardId={cardId} data={data} sendFollowUp={sendFollowUp} />;
    case 'mail_digest':
      return <MailDigestCard cardId={cardId} data={data} sendFollowUp={sendFollowUp} />;
    case 'mail_draft':
      return <MailDraftCard data={data} sendFollowUp={sendFollowUp} />;
    case 'mail_confirm':
      return <MailConfirmCard card={card} data={data} sendFollowUp={sendFollowUp} />;
    case 'mail_result':
      return <MailResultCard data={data} sendFollowUp={sendFollowUp} />;
    case 'mail_unsubscribe_picker':
      return <MailUnsubscribePickerCard key={typeof data.scan_id === 'string' ? data.scan_id : ''} data={data} sendFollowUp={sendFollowUp} />;
    case 'mail_link':
      return <MailLinkCard data={data} onOpenTarget={onOpenTarget} />;
    default:
      return null;
  }
}
